const VolunteerFriendInitialText ="Sometimes it can be more fun to volunteer if " +
    "you bring a friend along.  What do you think?  Would you like to invite " +
    "a friend to join you when you volunteer? " +
    "If you decide to select a friend, the mood points you earn may be increased " +
    "or decreased depending on the friend you select."
        
export default VolunteerFriendInitialText 
 